import $ from "jquery";

const __listProductsCustomizer2 = (addOnsList) => {
  const el = {
    input: ".js-buy-products__input",
    form: ".js-Customizer__Form",
  };
  const productId = $(el.form).data("product_id");
  if (!productId) return;

  const productAddOnsIds = Object.values(addOnsList).map((aol) => {
    return aol["customizer-option"];
  });

  const allProductIds = [productId.toString(), ...productAddOnsIds];

  $(el.input).val(JSON.stringify(allProductIds));
};

export default __listProductsCustomizer2;
